import * as React from 'react';
import styled from 'styled-components';
export const HeaderWrapper = styled.div `
  height: 40px;
  margin: 0 8px;
  color: #355C7E;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export function SubscriptionBenefits() {
    return (React.createElement("div", { className: "subscription-benefits subscription-reminder py-3" },
        React.createElement("p", { className: "icon-list-header py-2 font-semibold" }, "Subscriptions Include:"),
        React.createElement("ul", { className: "icon-list list-none pl-0" },
            React.createElement("li", { className: "icon-list-item mb-3 flex items-center" },
                React.createElement("i", { className: "vp-icon-truck-light pr-3 w-7 h-4 fill-[#637e96]", "aria-hidden": "true" }),
                " Free Shipping"),
            React.createElement("li", { className: "icon-list-item mb-3 flex items-center" },
                React.createElement("i", { className: "vp-icon-circle-x-light pr-3 w-7 h-4 fill-[#637e96]", "aria-hidden": "true" }),
                " Cancel anytime"),
            React.createElement("li", { className: "icon-list-item mb-3 flex items-center" },
                React.createElement("i", { className: "vp-icon-tag-light pr-3 w-7 h-4 fill-[#637e96]", "aria-hidden": "true" }),
                " 15% off all orders"))));
}
